import typoMixin from '@/styles/mixins/typo-mixin'
import { makeStyles, css } from '@conexasaude/hero'

const useStyles = makeStyles({
  indicators: ({ colors }) => css`
    display: flex;
    gap: 7.5px;

    > span {
      width: 100%;
      height: 4px;
      border-radius: 25px;
      background-color: ${colors.neutral[200]};
      transition: 0.2s;

      &.password-strength__indicator {
        &--weak {
          background-color: ${colors.danger[500]};
        }

        &--medium {
          background-color: ${colors.warning[500]};
        }

        &--strong {
          background-color: ${colors.success[500]};
        }
      }
    }
  `,

  tip: ({ typography, colors }) => css`
    &.password-strength__tip {
      display: inline-flex;
      margin-top: 4px;
      ${typoMixin({ typography }, 'microCopy')};

      &--weak {
        color: ${colors.danger[500]};
      }

      &--medium {
        color: ${colors.warning[500]};
      }

      &--strong {
        color: ${colors.success[500]};
      }
    }
  `,
})

export { useStyles }
